import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const applicationApi = createApi({
	reducerPath: 'applicationApi',
	baseQuery: fetchBaseQuery({
		baseUrl: ''
	}),
	tagTypes: [],
	endpoints: (builder) => ({
		// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
		fetchVersion: builder.query<{ version: string }, void>({
			query: () => '/version.json'
		})
	})
});

export const { useFetchVersionQuery } = applicationApi;
